module.exports = __webpack_public_path__ + "img/mail.1adc0ec.svg";